import { Size } from '@ps/web-core-enums';
import type { Reference } from '@ps/web-martech-cms-types';
import { useScreenSize } from '@ps/web-shared-components';
import type { SportsReference } from '@ps/web-sports-page-types';
import classNames from 'clsx';
import React, { forwardRef, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { CMSReferences, useStickyTopHeaderClassName } from '@swf/cms';
import { useRefs } from '@swf/core/providers/RefsProvider';
import { select } from '@swf/core/store';

import useSetHeaderHeight from '../../hooks/useSetHeaderHeight';

import styles from './Top.scss';

const Top = forwardRef<HTMLDivElement, { references: Reference[] | SportsReference[] }>(
  ({ references }, ref) => {
    const isMobileStickyTop = useSelector(select.sports.isMobileStickyQuickLinksEnabled);
    const { greaterThan } = useScreenSize();
    const isMobileScreenSize = !greaterThan(Size.XXSmall);
    const { isStickyHeader: isStickyTopHeader } = useStickyTopHeaderClassName('header');
    const { refs } = useRefs();
    const layoutRef = refs.get('sportsLayout');
    const [, updateState] = useState<Record<string, unknown>>();
    const forceUpdate = useCallback(() => updateState({}), []);

    useSetHeaderHeight('--sportsLayoutTopHeaderHeight', layoutRef, refs.get('topHeader'));

    useEffect(() => forceUpdate(), [forceUpdate]);

    return (
      <div
        ref={ref}
        className={classNames({
          [isStickyTopHeader
            ? styles.stickyTopWithStickyTopHeader
            : styles.stickyTopWithoutStickyTopHeader]: isMobileStickyTop && isMobileScreenSize
        })}
      >
        <CMSReferences references={references} />
      </div>
    );
  }
);

export default Top;
